import { render, staticRenderFns } from "./Shujuzhongxin.vue?vue&type=template&id=ba235ed4&scoped=true&"
import script from "./Shujuzhongxin.vue?vue&type=script&lang=js&"
export * from "./Shujuzhongxin.vue?vue&type=script&lang=js&"
import style0 from "./Shujuzhongxin.vue?vue&type=style&index=0&id=ba235ed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba235ed4",
  null
  
)

export default component.exports